import {AppBar, AppBarProps, Container, Grid, Link as MuiLink, Toolbar, Typography} from "@mui/material";
import React from "react";
import {LogoVertical} from "~/ui/icons";
import {ProfileButton} from "~/auth/components/ProfileButton";
import {FeedbackButton} from "~/components/FeedbackButton";
import {useHistory} from "react-router-dom";


export type MainAppBarProps = AppBarProps & {
    disableActions?: boolean
};


export const MainAppBar = (props: MainAppBarProps) => {
    const {disableActions, ...other} = props;
    const history = useHistory();

    const handleMainScreenClick = () => {
        history.push("/");
    }

    return (
        <>
            <AppBar position="fixed" color="inherit" {...other}>
                <Container disableGutters>
                    <Toolbar>
                        <MuiLink underline="none" color="inherit" onClick={handleMainScreenClick}>
                            <Grid container alignItems="center" component="span">
                                <LogoVertical style={{ height: 40 }}/>
                                <Typography variant="headerTitle"  color="primary" style={{marginLeft: 8}}>
                                    Порт в кармане
                                </Typography>
                            </Grid>
                        </MuiLink>
                        <div style={{flexGrow: 1}}/>
                        {!disableActions && (
                            <>
                                <FeedbackButton color="primary" size="large" variant="icon"/>
                                <ProfileButton edge="end" color="primary" size="large" id="appBar.profileButton"/>
                            </>
                        )}
                    </Toolbar>
                </Container>
            </AppBar>
        </>
    )
}